__turbopack_context__.v({
  "arrow": "purxuG_arrow",
  "item": "purxuG_item",
});
